import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import { ClientModel } from "..";

var AbstractPost = /*#__PURE__*/function (_ClientModel) {
  _inherits(AbstractPost, _ClientModel);

  var _super = _createSuper(AbstractPost);

  function AbstractPost() {
    _classCallCheck(this, AbstractPost);

    return _super.apply(this, arguments);
  }

  _createClass(AbstractPost, [{
    key: "transformDataForPersist",
    value: function transformDataForPersist() {
      var _data$title, _data$content;

      var data = _objectSpread({}, _get(_getPrototypeOf(AbstractPost.prototype), "transformDataForPersist", this).call(this));

      data.title = (_data$title = data.title) === null || _data$title === void 0 ? void 0 : _data$title.rendered;
      data.content = (_data$content = data.content) === null || _data$content === void 0 ? void 0 : _data$content.rendered;
      delete data._links;
      delete data.link;
      return data;
    }
  }, {
    key: "transformDataForPatch",
    value: function transformDataForPatch() {
      return this.transformDataForPersist();
    }
  }]);

  return AbstractPost;
}(ClientModel);

export { AbstractPost };